export default __webpack_public_path__ + "static/media/Íconos 03.6f8365db.png";